'use client';

import { cn } from '@/lib/utils';

export interface ForfaitOption {
  id: string;
  label: string;
  priceMonthly: number | null; // null si non disponible en mensuel
  priceAnnual: number | null;  // null si non disponible en annuel
}

interface ForfaitSelectorProps {
  options: ForfaitOption[];
  selectedId: string;
  onSelect: (id: string) => void;
  isAnnual: boolean;
  colorScheme?: 'green' | 'blue';
}

export function ForfaitSelector({
  options,
  selectedId,
  onSelect,
  isAnnual,
  colorScheme = 'green',
}: ForfaitSelectorProps) {
  // Filtrer les options disponibles selon le mode (mensuel/annuel)
  const availableOptions = options.filter((opt) =>
    isAnnual ? opt.priceAnnual !== null : opt.priceMonthly !== null
  );

  const baseColor = colorScheme === 'green' ? 'primaryGreen' : 'primaryBlue';

  return (
    <div className="flex flex-wrap gap-2 justify-center">
      {availableOptions.map((option) => {
        const isSelected = selectedId === option.id;
        const price = isAnnual ? option.priceAnnual : option.priceMonthly;

        return (
          <button
            key={option.id}
            type="button"
            onClick={() => onSelect(option.id)}
            className={cn(
              'px-4 py-2 rounded-full text-sm font-medium transition-all border-2',
              isSelected
                ? colorScheme === 'green'
                  ? 'bg-primaryGreen text-white border-primaryGreen'
                  : 'bg-primaryBlue text-white border-primaryBlue'
                : colorScheme === 'green'
                ? 'bg-white text-primaryGreen border-primaryGreen hover:bg-primaryGreen/10'
                : 'bg-white text-primaryBlue border-primaryBlue hover:bg-primaryBlue/10'
            )}
          >
            <span className="font-semibold">{option.label}</span>
          </button>
        );
      })}
    </div>
  );
}
